import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Footer from "../Shared/Footer/Footer";
import Navigation from "../Shared/Navigation/Navigation";

const Register = () => {
  const [loginData, setLoginData] = useState({});
  const navigate = useNavigate();
  const { user, registerUser, isLoading, authError } = useAuth();

  const handleOnBlur = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (loginData.password !== loginData.password2) {
      alert("Passwords do not match.");
      return;
    }
    registerUser(loginData.email, loginData.password, loginData.name);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navigation />

      <main className="flex-grow flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-4xl flex rounded-3xl overflow-hidden shadow-xl bg-white">
          {/* Left Panel */}
          <div className="hidden md:flex w-5/12 bg-slate-900 flex-col items-center justify-center p-10 text-white text-center">
            <span className="text-6xl mb-5">🐾</span>
            <h2 className="text-2xl font-bold mb-3">Join PetHouse</h2>
            <p className="text-slate-400 text-sm leading-relaxed">
              Create an account to start browsing, booking, and bringing home
              your new best friend.
            </p>
          </div>

          {/* Right Panel — form */}
          <div className="w-full md:w-7/12 p-8 sm:p-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-1">
              Create Account
            </h2>
            <p className="text-sm text-slate-400 mb-8">
              Already have an account?{" "}
              <Link to="/login" className="text-amber-500 font-semibold hover:underline">
                Login here
              </Link>
            </p>

            {isLoading ? (
              <div className="flex justify-center py-10">
                <div className="w-8 h-8 border-4 border-amber-400 border-t-transparent rounded-full animate-spin" />
              </div>
            ) : (
              <form onSubmit={handleLoginSubmit} className="space-y-5">
                {/* Full Name */}
                <div>
                  <label htmlFor="name" className="block text-xs font-medium text-slate-500 mb-1.5">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    onBlur={handleOnBlur}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent transition"
                    placeholder="John Doe"
                    required
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-xs font-medium text-slate-500 mb-1.5">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    onBlur={handleOnBlur}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent transition"
                    placeholder="you@example.com"
                    required
                  />
                </div>

                {/* Passwords side by side */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="password" className="block text-xs font-medium text-slate-500 mb-1.5">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      onBlur={handleOnBlur}
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent transition"
                      placeholder="••••••••"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="password2" className="block text-xs font-medium text-slate-500 mb-1.5">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      name="password2"
                      id="password2"
                      onBlur={handleOnBlur}
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent transition"
                      placeholder="••••••••"
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full py-2.5 bg-slate-900 text-white rounded-lg font-medium hover:bg-amber-500 hover:text-slate-900 transition-all duration-300 mt-2"
                >
                  Create Account
                </button>
              </form>
            )}

            {user?.email && (
              <p className="mt-6 text-center text-green-600 text-sm font-semibold">
                ✓ Account created!
              </p>
            )}
            {authError && (
              <p className="mt-4 text-center text-red-500 text-sm">{authError}</p>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Register;
